import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { formatNull, formatDate, isDatePastInMoscow } from '../../../Utils/GlobalUtils';

import Modal from '../../Modal';
import EditInsuranceCase from './Modals/EditInsuranceCase';

const InsuranceCasePanel = ({ caseId }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-main-case-insurance?case_id=${caseId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then((response) => {
            setFormInfo(response.data);
        })
        .catch((error) => {
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, caseId]);

    const [isEditModal, setIsEditModal] = React.useState(false);

    const [isShowSec, setIsShowSec] = React.useState(false);


    return (
        <>
            <Modal isOpen={isEditModal} closeModal={() => setIsEditModal(false)}>
                <EditInsuranceCase caseId={caseId} onSuccess={() => setReload(true)} />
            </Modal>

            <div className='panel linksPanel'>
                <h3>Основная информация</h3>
                <p>Балансовая стоимость активов должника на момент введения процедуры по данным ФНС: {formatNull(formInfo.asset_value_gov)} ₽</p>
                <p>Балансовая стоимость активов должника по данным управляющего: {formatNull(formInfo.asset_value_am)} ₽</p>
                <button type='button' className='tableButton' onClick={() => setIsEditModal(true)}>Указать сумму</button>
            </div>
        </>
    )
}

export default InsuranceCasePanel;